import { css } from '@emotion/react';
import { hexToRgba } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
var notificationStaticStyle = css({
    backgroundColor: theme.background.contrast,
    borderRadius: tokens.borderRadius.medium,
    display: 'flex',
    padding: '12px',
    position: 'relative',
});
export function notificationStyle(_a) {
    var variant = _a.variant;
    var borderColor = hexToRgba(variant === 'warning' ? theme[variant].lighter : theme[variant].main, 0.6);
    return [
        notificationStaticStyle,
        css({
            border: "".concat(tokens.borderWidth.thin, " solid ").concat(borderColor),
        }),
    ];
}
var contentStaticStyle = css({
    alignSelf: 'center',
    paddingLeft: tokens.spacing.small,
});
export function contentStyle(_a) {
    var closable = _a.closable, isContentCentered = _a.isContentCentered;
    return [
        contentStaticStyle,
        closable && css({ paddingRight: tokens.spacing.small }),
        !isContentCentered && css({ flexGrow: 1 }),
    ];
}
export var closeButtonStaticStyle = css({
    color: theme.text.main,
    flexShrink: 0,
    marginLeft: 'auto',
});
